import type { FunctionComponent } from 'preact';
import { Fragment } from 'preact';
import { useErrorBoundary } from 'preact/hooks';

/** 무슨 이유인지 제대로 동작 안한다. class 컴포넌트로 만들어도 동작 안함 */
export const ErrorBoundary: FunctionComponent = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [error, resetError] = useErrorBoundary((error) => {
    console.log(error);
  });

  if (error) {
    return (
      <div>
        <p>{error?.message}</p>
        <button onClick={resetError}>Try again</button>
      </div>
    );
  }

  return <Fragment>{props.children}</Fragment>;
};
